<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <section class="account" v-else>
      <div
        class="bg-light pt-3 px-4 border-bottom border-grey"
      >
        <div v-for="(tab, index) in tabs" class="ml-0 d-inline" :key="index">
          <span
            v-if="testTab(index)"
            :class="
              activeTabId == tab.id
                ? 'active border-bottom-3 border-primary'
                : ''
            "
            class="p-0 it-tabs pb-2 mr-3 bg-transparent"
            type="button"
            @click="changeTab(index)"
          >
            {{ tab.title }}
          </span>
        </div>
      </div>
      <div class="contenedor">
        <LoadingSpinner v-if="timeSaving" />
        <!-- Tab set my availability -->
        <div
          class="col-md-12 mt-4 ml-15"
          v-if="activeTabId == 3 && !timeSaving"
        >
          <div v-if="showFormTimeAvailable">
            <div class="field-ckeditor-wrappar">
              <div
                class="form-group valid featured required col-sm-12 field-treeselect field-ckeditor"
              >
                <label>{{ $t("lang.label.timeavailability") }}</label>
                <CalendarAvailability
                  v-if="!loading"
                  :hours="hours"
                  :avalibleSlots="calendarAvailability"
                  @SetAvailability="SetAvailability"
                />
                <!-- <IndustrySearch
                :option_list="hours"
                :default_values="selectedHours"
              >
              </IndustrySearch> -->
                <div class="errors help-block">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div
              v-if="clientNylas.account_id && clientNylas.activated_spark == 1"
                class="form-group valid featured required col-md-12 field-select"
              >
                <AllCalendarTypes
                  :account_id="clientNylas.account_id"
                  :calendar_ids="calendar_ids"
                  :calendar_select="calendar_id_selected"
                  @updated="updateData($event)"
                  @updateSelected="updateSelectCalendar($event)"
                />
              </div>
            </div>
            <div v-if="!loading">
              <vue-form-generator
                ref="calendarForm"
                :schema="schemaCalendar"
                :model="modelCalendar"
                :options="formOptions"
              ></vue-form-generator>

              <div class="col-md-12 mt-3">
                <label>{{ $t("lang.calendar.not_available_dates") }}</label>
                <div v-if="modelCalendar.not_available_dates.length" class="row mb-1">
                  <div class="col-md-5">
                    <small class="font-weight-bold">{{ $t("lang.calendar.not_available_from") }}</small>
                  </div>
                  <div class="col-md-5">
                    <small class="font-weight-bold">{{ $t("lang.calendar.not_available_to") }}</small>
                  </div>
                </div>
                <div
                  class="row mb-2"
                  v-for="(range, index) in modelCalendar.not_available_dates"
                  :key="index"
                >
                  <div class="col-md-5">
                    <input type="date" class="form-control" v-model="range.from" />
                  </div>
                  <div class="col-md-5">
                    <input type="date" class="form-control" v-model="range.to" />
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-sm btn-danger w-100" @click="removeNotAvailableDate(index)">
                      {{ $t("lang.button.delete") }}
                    </button>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary" @click="addNotAvailableDate">
                  {{ $t("lang.calendar.add_not_available_date_range") }}
                </button>
              </div>

            </div>
            <button
              class="w-100 m-3 btn btn-sm btn-success"
              @click="saveTimeAvailable()"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
          <div v-else class="card border-danger mb-3">
            <div class="card-body text-danger">
              <p class="card-text">
                {{ $t("lang.calendar.calendar_of_other_user") }}.
              </p>
            </div>
          </div>
        </div>

        <!-- Tab - Syncronization -->
        <div class="card mt-3" v-if="activeTabId == 1">
          <div class="body p-4 email-account">
            <!-- Main select -->
            <span class="ml-3 my-3">
              {{ $t('lang.calendar.question_syncronization')}}
            </span>
            <div class="col-12 mb-4">
              <IndustrySearch
                :option_list="calendarNylasAccounts"
                :default_values="calendarSelected"
                :isDisabled="
                  saving || loadingCalendarSelected || showSyncForm()
                "
                :multiple="false"
                @selected="itemSelected"
              >
              </IndustrySearch>
            </div>
            <!-- End Main select -->


            <div
              v-if="loadingCalendarSelected"
              class="col-2 btn-processing text-left pt-1"
            >
              <i class="icon-spinner"></i>
            </div>

            <!-- Link calendar of other user the my team-->
            <small
                v-if="showLink > 0 && calendar_link != '' && parseInt(calendarSelected[0]) > 2 "
                class="ml-4 font-weight-bold text-primary"
              >
                <i class="icon-calendar mr-1"></i>
                <a target="_blank" :href="calendar_link">{{
                  calendar_link
                }}</a>
            </small>

            <!-- Agenda OliverList (option 1)
            <div v-if="calendarSelected[0] === '1'">
               <p class="ml-4 mb-4">
                  <small class="text-muted">{{ $t('lang.calendar.agenda_oliver') }}</small>
                </p>
                <h5 class="bold ml-4 mb-2">
                  Agenda Oliverlist
                </h5>
                <ul class="list-unstyled pl-4 pt-3">
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.prospects') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.agenda_alias') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.invitations') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.meetings') }}
                      </span>
                  </li>
                </ul>
            </div> -->
            
            <!-- Your owner agenda (option 2)-->
            <div v-if="calendarSelected[0] == '2'">

              <!-- When calendar is syncronized -->
              <div v-if="!savingData">
              <div
                class="col-md-12 pb-3 mt-5"
                v-if="
                  settings.email &&
                  !addAccount &&
                  showSyncForm() &&
                  !loadingCalendarSelected &&
                  showFormTimeAvailable
                "
              >
                <span>
                  <p v-if="showCalendar()" class="font-weight-bold mb-2">
                    Calendar sync:
                  </p>
                  <p v-else class="font-weight-bold mb-2">Email sync:</p>
                </span>
                <div class="card rounded-0">
                  <div class="card-body row">
                    <div class="col-md-1 text-center">
                      <span v-if="isGmailServer" class="d-block icon-account">
                        <img
                          v-if="showCalendar()"
                          class="mx-auto"
                          src="@/assets/images/google-calendar.jpeg"
                          alt
                        />
                        <img
                          v-else
                          class="mx-auto"
                          src="@/assets/images/gmail.png"
                          alt
                        />
                      </span>
                      <span v-if="isExchangeServer" class="d-block icon-account">
                        <img
                          v-if="showCalendar()"
                          class="mx-auto"
                          src="@/assets/images/outlook-calendar.png"
                          alt
                        />
                        <img
                          v-else
                          class="mx-auto"
                          src="@/assets/images/outlook.png"
                          alt
                        />
                      </span>
                      <span
                        v-if="isSmtpServer"
                        class="icon-envelope-open-o d-block icon-account"
                      ></span>
                    </div>
                    <div class="col-md-9 d-block">
                      <span
                        ><p class="font-weight-bold small">
                          {{ this.settings.email }}
                        </p></span
                      >
                      <br />
                      <div v-if="settings.activated == 1">
                        <i class="icon-check1 text-success small mr-1"></i
                        ><span
                          ><p class="font-weight-light text-success small">
                            Active
                          </p></span
                        >
                      </div>
                      <div v-else>
                        <span
                          ><p class="font-weight-light small">
                            {{ $t("lang.label.disconnected") }}
                          </p></span
                        >
                      </div>

                      <small
                        v-if="showCalendar() && settings.activated == 1"
                        class="font-weight-bold text-primary"
                      >
                        <i class="icon-calendar mr-1"></i>

                        <a
                          v-if="vueAppEnv() != 'local'"
                          target="_blank"
                          :href="calendar_link"
                          >{{ calendar_link }}</a
                        >
                        <a
                          v-else
                          target="_blank"
                          :href="
                            'https://dev.oliverlists.com/mycalendar/' +
                            getUserHash()
                          "
                          >https://dev.oliverlists.com/mycalendar/{{
                            getUserHash()
                          }}</a
                        >
                      </small>
                      <!-- <i class="icon-warning text-warning small mr-1"></i><span><p class="font-weight-light text-warning small">Authentication Error</p></span> -->
                    </div>

                    <div class="col-md-2 text-right mt-2 d-flex flex-column">
                      <button
                        class="btn btn-sm btn-danger"
                        @click="deactivate()"
                        v-if="this.settings.activated == 1"
                        :disabled="this.user.role_id == 1"
                      >
                        {{ $t("lang.label.stopsyncing") }}
                      </button>
                        <button
                        class="btn btn-sm btn-warning mt-2"
                        @click="deleteAgenda()"
                        v-if="this.settings.activated == 1"
                        :disabled="this.user.role_id == 1"
                      >
                        {{ $t("lang.label.deleteAgenda") }}
                      </button>
                      <button
                        class="btn btn-sm btn-success"
                        @click="reconnect()"
                        v-else
                      >
                        {{ $t("lang.label.reconnect") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Agenda OliverList (Ex option 1)-->
            <div v-else-if="!active">
               <p class="ml-4 mb-4">
                  <small class="text-muted">{{ $t('lang.calendar.agenda_oliver') }}</small>
                </p>
                <h5 class="bold ml-4 mb-2">
                  Agenda Oliverlist
                </h5>
                <ul class="list-unstyled pl-4 pt-3">
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.prospects') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.agenda_alias') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.invitations') }}
                      </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-2"></i
                    ><span>
                        {{ $t('lang.calendar.meetings') }}
                      </span>
                  </li>
                </ul>
            </div>
                <div v-else-if="active">
                  <p class="ml-4 mb-4">
                    <small class="text-muted">{{ $t('lang.calendar.availabilities')}}</small>
                  </p>
                  <h5 class="bold ml-4 mb-2">
                    {{ $t("lang.label.unlockyoursalesinboxadvancedCalendar") }}
                  </h5>
                  <ul class="list-unstyled pl-4 pt-3">
                    <li>
                      <i class="icon-check1 text-success mr-2"></i
                      ><span>
                          {{ $t('lang.calendar.prospects_availabilities')}}
                        </span>
                    </li>
                    <li>
                      <i class="icon-check1 text-success mr-2"></i
                      ><span>
                          {{ $t('lang.calendar.meetings')}}
                        </span>
                    </li>
                    <li>
                      <i class="icon-check1 text-success mr-2"></i
                      ><span>
                          {{ $t('lang.calendar.add_meeting')}}
                        </span>
                    </li>
                  </ul>

                  <div
                  class="d-flex align-items-center ml-4"
                  v-if="!addAccount && showFormTimeAvailable"
                >
                  <!-- <button
                    class="btn btn-sm btn-success btn-sm mt-4 mb-3 mr-2"
                    @click="addNewAccount()"
                  >
                    {{ $t("lang.label.addnewaccount") }}
                  </button> -->
                </div>
                </div>

                <!-- If you want to  a new account -->
                <!-- settings.email &&
                  !addAccount &&
                  showSyncForm() &&
                  !loadingCalendarSelected &&
                  showFormTimeAvailable -->
              <div class="ml-2" v-if="( settings && settings.activated != '1') || !hasEmailSyncronized">
                <div class="col-sm-12 pb-3 mt-4">
                  <span
                    ><p class="font-weight-light">
                      {{
                        $t(
                          "lang.label.selectyouremailproviderandclickonconnecttosynchronizeyoumailbox"
                        )
                      }}
                    </p></span
                  >
                </div>
                <button
                  v-if="!isSmtpServer"
                  type="button"
                  class="btn btn-light border ml-2"
                  :class="isGmailSelected ? 'active' : ''"
                  @click="changeEmailProvider('Gmail')"
                >
                  <span class="d-block icon"
                    ><img class="mx-auto" src="@/assets/images/gmail.png" alt
                  /></span>
                  Gmail/Gsuite
                </button>
                <button
                  v-if="!isSmtpServer "
                  type="button"
                  class="btn btn-light border ml-2"
                  :class="isExchangeSelected ? 'active' : ''"
                  @click="changeEmailProvider('Exchange')"
                >
                  <span class="d-block icon"
                    ><img src="@/assets/images/outlook.png" alt
                  /></span>
                  Outlook/Exchange
                </button>
                <button
                  v-if="!isGmailServer && !isExchangeServer && smtp && false"
                  type="button"
                  class="btn btn-light border ml-2"
                  :class="isSmtpSelected ? 'active' : ''"
                  @click="changeEmailProvider('SMTP')"
                >
                  <span class="icon-envelope-open-o d-block icon"></span>
                  IMAP/SMTP
                </button>

                <div v-if="isSmtpSelected && smtp">
                  <p class="ml-5 mt-4">
                    <Tutorial
                      id="smtpimap"
                      :linkText="$t('lang.label.smtp')"
                      linkClass="ml-2 mt-2"
                      :videoUrl="
                        'https://www.youtube.com/embed/' +
                        $t('lang.videos.emailsmtp')
                      "
                    >
                      <template slot="info" slot-scope="{ info }">
                        <table class="table table-sm" v-if="false">
                          <thead>
                            <tr>
                              <th scope="col">
                                {{ $t("lang.label.emailprovider") }}
                              </th>
                              <th scope="col">
                                {{ $t("lang.label.imapserverincomingmessages") }}
                              </th>
                              <th scope="col">
                                {{ $t("lang.label.smtpserveroutgoingmessages") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">Gmail</th>
                              <td>imap.gmail.com / Port : 993</td>
                              <td>smtp.gmail.com / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Outlook</th>
                              <td>imap-mail.outlook.com / Port : 993</td>
                              <td>smtp-mail.outlook.com / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">OVH</th>
                              <td>ssl0.ovh.net / Port : 993</td>
                              <td>ssl0.ovh.net / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Gandi</th>
                              <td>mail.gandi.net / Port : 993</td>
                              <td>mail.gandi.net / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Ionos</th>
                              <td>imap.ionos.fr / Port : 993</td>
                              <td>smtp.ionos.fr / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Office365</th>
                              <td>outlook.office365.com / Port : 993</td>
                              <td>smtp.office365.com / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Yahoo</th>
                              <td>imap.mail.yahoo.com / Port : 993</td>
                              <td>smtp.mail.yahoo.com / Port : 465</td>
                            </tr>
                            <tr>
                              <th scope="row">AOL</th>
                              <td>imap.aol.com / Port : 993</td>
                              <td>smtp.aol.com / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">1&1</th>
                              <td>imap.1and1.com / Port : 993</td>
                              <td>smtp.1and1.com / Port : 587</td>
                            </tr>
                            <tr>
                              <th scope="row">Zoho</th>
                              <td>imap.zoho.com / Port : 993</td>
                              <td>smtp.zoho.com / Port : 465</td>
                            </tr>
                            <tr>
                              <th scope="row">Mail.com</th>
                              <td>imap.mail.com / Port : 993</td>
                              <td>smtp.mail.com / Port : 587</td>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                    </Tutorial>
                  </p>
                </div>
                <div>
                  <EmailProviderGmail
                    :settings="settings"
                    :selectedUserId="selectedUserIdTemp"
                    :provider="emailProvider"
                  />
                </div>
              </div>

              </div>
              <div v-else>
                <LoadingSpinner />
              </div>
            </div>

            <!-- Agenda calender of other user -->
            <div class="mb-4 p-0" v-if="Number(calendarSelected[0]) > 2">
              <span class="ml-4 mt-4 h6">
                {{ $t('lang.calendar.team_schedule')}}
              </span>

              <ul class="list-unstyled pl-4 pt-3">
                <li>
                  <i class="icon-check1 text-success mr-2"></i
                  ><span>
                    {{ $t('lang.calendar.team_prospects')}}
                  </span>
                </li>

                <li>
                  <i class="icon-check1 text-success mr-2"></i
                  ><span>
                    {{ $t('lang.calendar.team_invitations')}}
                  </span>
                </li>

                <li>
                  <i class="icon-check1 text-success mr-2"></i
                  ><span>
                    {{ $t('lang.calendar.team_meetings')}}
                  </span>
                </li>
              </ul>
            </div>

            <!-- Email integration main screen -->
            <div
              class="col-sm-12 pb-3"
              v-if="
                (!this.settings.email || this.settings.activated == 0) &&
                !loadingCalendarSelected
              "
            >
              <div v-if="!showCalendar()">
                <h5 class="bold mb-4">
                  {{ $t("lang.label.unlockyoursalesinboxadvanced") }}
                </h5>

                <span v-if="user.role_id != 3"
                  ><p class="font-weight-light">
                    {{
                      $t(
                        "lang.label.tabswitchingandmanuallyforwardinfemailstooliverisathingofthepastwhenunlockedyoucanuseryoursalesinboxtosendemaildirectlyfromoliverwhileautomaticallylinkingthemtorelateddealsandcontacts"
                      )
                    }}
                  </p></span
                >
                <ul v-if="user.role_id != 3" class="list-unstyled pl-4 pt-3">
                  <li>
                    <i class="icon-check1 text-success mr-1"></i
                    ><span>
                      {{
                        $t(
                          "lang.label.syncoliveremailswithanymajoremailprovider"
                        )
                      }}
                    </span>
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-1"></i
                    ><span>
                      {{ $t("lang.label.trackemailopensandclicks") }}</span
                    >
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-1"></i
                    ><span>
                      {{
                        $t(
                          "lang.label.savetimebymakinguseofcustomizabletemplates"
                        )
                      }}</span
                    >
                  </li>
                  <li>
                    <i class="icon-check1 text-success mr-1"></i
                    ><span>
                      {{
                        $t(
                          "lang.label.customizeyoursignatureforamoreprofessionallook"
                        )
                      }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="divider mb-4" v-if="showCalendar()"></div>
            <div class="col-md-6" v-if="showCalendar()">
              <div>
                <!-- Button save -->
                <div class="d-flex align-items-center" v-if="!showSyncForm() && calendarSelected[0] != '2'">
                  <!-- :disabled="showSyncForm()" -->
                  <button
                    class="btn btn-sm btn-primary btn-sm mt-4 mb-3 mr-2 btn-processing"
                    :class="{ loading: loadingCalendarSelected }"
                    @click="connectExistant()"
                    :disabled="
                      saving ||
                      loadingCalendarSelected ||
                      showSyncForm()
                    "
                  >
                    <span v-if="!saving">{{ $t("lang.button.save") }}</span>
                    <span v-else>
                      <i class="icon-spinner mr-2"></i>
                      {{ $t("lang.button.saving") }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div id="accordion" v-if="user.role_id != 3">
              <div class="card" v-if="false">
                <div class="card-header" id="headingOne">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      {{ $t("lang.label.gmail") }}
                    </button>
                  </h5>
                </div>
                <div
                  id="collapseOne"
                  class="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <span
                      ><p class="font-weight-light mt-2">
                        {{ $t("lang.label.explicationgmail") }}
                      </p></span
                    >
                    <div class="col-6 mt-4">
                      <h5 class="">{{ $t("lang.label.step1") }}</h5>
                      <span
                        ><p class="font-weight-light">
                          {{
                            $t(
                              "lang.label.giveauthorizationstotheOliverapplicationfortheprocessing"
                            )
                          }}
                        </p></span
                      >
                      <div class="embed-responsive embed-responsive-16by9 mt-3">
                        <iframe
                          class="embed-responsive-item"
                          src="https://player.vimeo.com/video/454079702"
                          allowfullscreen
                        ></iframe>
                      </div>
                    </div>
                    <div class="col-6 mt-4">
                      <h5 class="">{{ $t("lang.label.step2") }}</h5>
                      <span
                        ><p class="font-weight-light">
                          {{
                            $t(
                              "lang.label.authorizetheoliverapplicationinthegooglesuiteadministrationpanel"
                            )
                          }}
                        </p></span
                      >
                      <small
                        ><p class="font-weight-bold mt-2">
                          {{ $t("lang.label.iddelapplication") }}
                        </p></small
                      >
                      <div class="embed-responsive embed-responsive-16by9 mt-3">
                        <iframe
                          class="embed-responsive-item"
                          src="https://player.vimeo.com/video/454100979"
                          allowfullscreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" v-if="false">
                <div class="card-header" id="headingTwo">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      {{ $t("lang.label.outlook") }}
                    </button>
                  </h5>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <div class="col-6 mt-4">
                      <div class="embed-responsive embed-responsive-16by9 mt-3">
                        <iframe
                          class="embed-responsive-item"
                          src="https://player.vimeo.com/video/454357528"
                          allowfullscreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" v-if="smtp">
                <div class="card-header" id="headingThree">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link collapsed"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      {{ $t("lang.label.smtp") }}
                    </button>
                  </h5>
                </div>
                <div
                  id="collapseThree"
                  class="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <span
                      ><p class="font-weight-light mt-2">
                        {{ $t("lang.label.introsmtp") }}
                      </p></span
                    >
                    <div class="col-6 mt-4">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ $t("lang.label.emailprovider") }}
                            </th>
                            <th scope="col">
                              {{ $t("lang.label.imapserverincomingmessages") }}
                            </th>
                            <th scope="col">
                              {{ $t("lang.label.smtpserveroutgoingmessages") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Gmail</th>
                            <td>imap.gmail.com / Port : 993</td>
                            <td>smtp.gmail.com / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Outlook</th>
                            <td>imap-mail.outlook.com / Port : 993</td>
                            <td>smtp-mail.outlook.com / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">OVH</th>
                            <td>ssl0.ovh.net / Port : 993</td>
                            <td>ssl0.ovh.net / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Gandi</th>
                            <td>mail.gandi.net / Port : 993</td>
                            <td>mail.gandi.net / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Ionos</th>
                            <td>imap.ionos.fr / Port : 993</td>
                            <td>smtp.ionos.fr / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Office365</th>
                            <td>outlook.office365.com / Port : 993</td>
                            <td>smtp.office365.com / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Yahoo</th>
                            <td>imap.mail.yahoo.com / Port : 993</td>
                            <td>smtp.mail.yahoo.com / Port : 465</td>
                          </tr>
                          <tr>
                            <th scope="row">AOL</th>
                            <td>imap.aol.com / Port : 993</td>
                            <td>smtp.aol.com / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">1&1</th>
                            <td>imap.1and1.com / Port : 993</td>
                            <td>smtp.1and1.com / Port : 587</td>
                          </tr>
                          <tr>
                            <th scope="row">Zoho</th>
                            <td>imap.zoho.com / Port : 993</td>
                            <td>smtp.zoho.com / Port : 465</td>
                          </tr>
                          <tr>
                            <th scope="row">Mail.com</th>
                            <td>imap.mail.com / Port : 993</td>
                            <td>smtp.mail.com / Port : 587</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <keep-alive v-for="tab in tabs" :key="tab.id">
            <component :is="tab.component" v-if="activeTabId == tab.id" />
          </keep-alive>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";

import CalendarAvailability from "@/components/Calendar/CalendarAvailability.vue";
import { availabilityHasOverlap } from "@/_helpers/timeSlots";
import {
  usersService,
  clientsService,
  smtpMailboxesService,
  campaignsService,
  myCalendarService,
  targetsService,
} from "@/_services";
import i18n from "@/_helpers/i18n";
import $ from "jquery";
import EmailProviderGmail from "@/components/Account/EmailProviderGmail";
import EmailProviderSMTP from "@/components/Account/EmailProviderSMTP";
import EmailTemplate from "@/components/Account/EmailTemplate";
import Tutorial from "@/components/Tutorial.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import VueFormGenerator from "vue-form-generator";
import AllCalendarTypes from "@/components/Calendar/AllCallendarTypes.vue";
import "vue-form-generator/dist/vfg.css";
import { setTimeout } from 'timers';
import TemplateMsg from '@/components/AccountCreation/Steps/Campaign/TemplateMsg.vue';

Vue.use(VueFormGenerator, {
  validators: {
    notAcceptNumberOrEmail: (value, field, model) => {
      const notNumber = /^([^0-9]*)$/;
      const notUrl = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
      if (!notNumber.test(value) || value.match(/@/gi) || value.match(notUrl)) {
        return [i18n.t("lang.validation.not_number_and_email")];
      } else {
        return [];
      }
    },
  },
});

export default {
  props: {
    selectedUserId: {
      type: String,
      default: null,
    },
  },
  data() {
    var self = this;

    return {
      hasEmailSynced: false,
      optionSelectInitial: null,
      savingData: false,
      selectedUserIdTemp: null,
      calendar_link: '',
      calendarClientNylasIdSaved: null,
      saving: false,
      showFormTimeAvailable: true,
      loadingCalendarSelected: false,
      timeSaving: false,
      calendar_ids: [],
      calendar_id_selected: "",
      checkIntegration: false,
      domaincalendar: "aivoni-ilimited.com",
      smtp: false,
      clientNylas: {},
      calendarNylasAccounts: [
        // { id: '1', label: this.$t('lang.calendar.alias') },
        { id: '2', label: this.$t('lang.calendar.your_agenda') },
      ],
      calendarSelected: ['2'],
      calendarsNylas: [],
      meetIntervalTime: [],
      delay_first_date: "",
      hours: [
        { id: 1, label: "00:00 hs" },
        { id: 2, label: "01:00 hs" },
        { id: 3, label: "02:00 hs" },
        { id: 4, label: "03:00 hs" },
        { id: 5, label: "04:00 hs" },
        { id: 6, label: "05:00 hs" },
        { id: 7, label: "06:00 hs" },
        { id: 8, label: "07:00 hs" },
        { id: 9, label: "08:00 hs" },
        { id: 10, label: "09:00 hs" },
        { id: 11, label: "10:00 hs" },
        { id: 12, label: "11:00 hs" },
        { id: 13, label: "12:00 hs" },
        { id: 14, label: "13:00 hs" },
        { id: 15, label: "14:00 hs" },
        { id: 16, label: "15:00 hs" },
        { id: 17, label: "16:00 hs" },
        { id: 18, label: "17:00 hs" },
        { id: 19, label: "18:00 hs" },
        { id: 20, label: "19:00 hs" },
        { id: 21, label: "20:00 hs" },
        { id: 22, label: "21:00 hs" },
        { id: 23, label: "22:00 hs" },
        { id: 24, label: "23:00 hs" },
      ],
      linkOption: "",
      selectedHours: [],
      linkOption: "",
      // selectedHours: [],
      calendarAvailability: [],
      loading: true,
      meetType: false,
      emailProvider: "Gmail",
      emailAccount: "",
      isChecked: false,
      settings: {},
      active: false,
      errors: [],
      info: [],
      isSmtpServer: false,
      isGmailServer: false,
      isExchangeServer: false,
      addAccount: false,
      tabs: [
        {
          id: 1,
          title: this.$t("lang.emailsettings.synchronization"),
          roles: [1,2, 3, 4],
        },
        {
          id: 2,
          title: this.$t("lang.emailsettings.templates"),
          component: "EmailTemplate",
          roles: [1],
        },
        {
          id: 3,
          title: this.$t("lang.calendar.set_my_availability"),
          roles: [1,3, 4],
        },
      ],
      activeTabId: 1,
      modelCalendar: {
        calendar_description: this.$t(
          "lang.appointments.calendar_description_value"
        ),
        duration_minutes: 30,
        max_appointments_day: 10,
        meet_type: 1,
        link_meet: "",
        delay_first_date: 1,
        interval_minutes: 0,
        not_available_dates: []
      },
      schemaCalendar: {
        fields: [
          {
            type: "select",
            label: this.$t("lang.appointments.meetduration"),
            model: "duration_minutes",
            featured: true,
            required: true,
            default: 1,
            values: function () {
              let options = [
                {
                  id: "10",
                  name: "10",
                },
                {
                  id: "15",
                  name: "15",
                },
                {
                  id: "20",
                  name: "20",
                },
                {
                  id: "30",
                  name: "30",
                },
                {
                  id: "45",
                  name: "45",
                },
                {
                  id: "60",
                  name: "60",
                },
              ];
              return options;
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6",
            onChanged: this.chengeDurationInterval,
          },
          {
            type: "select",
            label: this.$t("lang.appointments.delay_first_date"),
            model: "delay_first_date",
            featured: true,
            required: true,
            default: 1,
            values: function () {
              let options = [
                {
                  id: "1",
                  name: "1",
                },
                {
                  id: "2",
                  name: "2",
                },
                {
                  id: "3",
                  name: "3",
                },
                {
                  id: "4",
                  name: "4",
                },
              ];
              return options;
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6"
          },
          {
            type: "select",
            label: this.$t("lang.appointments.intervalmeet"),
            model: "interval_minutes",
            featured: true,
            required: true,
            default: 1,
            values: function () {
              let options = self.meetIntervalTime;
              return options;
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.maxappointments"),
            min: 3,
            model: "max_appointments_day",
            value: 10,
            featured: true,
            required: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.number,
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: this.$t("lang.label.timezone"),
            model: "timezone_id",
            featured: true,
            required: true,
            values: function () {
              return self.timezones;
            },
            selectOptions: {
              value: "id",
              name: "label",
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6",
          },
          {
            type: "textArea",
            label: this.$t("lang.appointments.calendar_description"),
            model: "calendar_description",
            featured: true,
            required: true,
            rows: 5,
            max: 250,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.notAcceptNumberOrEmail,
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: this.$t("lang.appointments.meettype"),
            model: "meet_type",
            featured: true,
            required: true,
            default: 1,
            values: function () {
              let options = [];
              options.push({
                id: "1",
                name: this.$t("lang.appointments.videocall"),
              });
              //if (["eas", "ews"].includes(self.settings.provider)) {
              //  options.push({ id: "3", name: "ZOOM" });
              //}
              options.push({
                id: "0",
                name: this.$t("lang.appointments.phone"),
              });
              // options.push({
              //   id: "2",
              //   name: this.$t("lang.appointments.other"),
              // });
              return options;
            },
            validator: VueFormGenerator.validators.required,
            styleClasses: "col-md-6",
            onChanged: this.changeMeetType,
          },
          {
            type: "input",
            inputType: "url",
            label: this.$t("lang.appointments.backup_link"),
            hint: this.$t("lang.appointments.backup_link_help"),
            model: "link_meet",
            placeholder: "https://",
            max: 255,
            required: false,
            visible: (model) => model && model.meet_type == 1,
            validator: VueFormGenerator.validators.url,
            styleClasses: "col-md-6",
          },

        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },

  components: {
    Header,
    LoadingSpinner,
    EmailProviderGmail,
    EmailProviderSMTP,
    Tutorial,
    EmailTemplate,
    IndustrySearch,
    CalendarAvailability,
    AllCalendarTypes,
    Tabs,
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      timezones: (state) => state.optionsList.all["timezones"].data,
    }),
    isSalesRep() {
      return ["3", "4"].includes(this.user.role_id);
    },
    user() {
      return this.$store.state.authentication.user;
    },
    isGmailSelected() {
      return this.emailProvider === "Gmail";
    },
    isExchangeSelected() {
      return this.emailProvider === "Exchange";
    },
    isSmtpSelected() {
      return this.emailProvider === "SMTP";
    },
    showLink() {
      if (
        this.calendarClientNylasIdSaved === null &&
        parseInt(this.calendarSelected[0])  > 2
      ) {
        return true;
      } else {
        if (this.calendarSelected[0] == '1') {
          return true;
        }
        //if (this.calendarSelected.length == 0) {
          if (this.calendarSelected[0] == '2' || this.calendarSelected.length == 0) {
          return false;
        } else {
          const email = this.calendarsNylas.find(
            (e) => e.id == this.calendarSelected[0]
          ).email;
          if (email) {
            if (email === this.settings.email) {
              if (this.calendarClientNylasIdSaved == this.calendarSelected[0]) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
        }
      }
    },
  },
  created() {

    this.showFormTimeAvailable = true
    if (this.selectedUserId == null) {
      this.selectedUserIdTemp = this.user.id;
    }

    this.meetType = false;
    this.loading = true;

    setTimeout(() => {
    clientsService.getCalendarNylas()
    .then((res) => {
      let obj;
      this.calendarsNylas = res;
      if (res.length > 0) {
        const promises = [];

        res.forEach((val) => {
          if (this.selectedUserIdTemp !== val.user_id) {
              obj = {};
              obj.label =
              val.first_name + " " + val.last_name + " (" + val.email + ")";
              obj.id = val.id;
              this.calendarNylasAccounts.push(obj);
              this.hasEmailSynced = true;

              if (this.selectedUserIdTemp == val.referenced_calendar_user_id) {
                this.calendarSelected = []; 
                this.calendarSelected.push(obj.id);
                this.chooseACalendar(obj.id);
              }            
          }
          promises.push(Promise.resolve());
        });

        Promise.all(promises).then(() => {
        // if( res.find( e => e.user_id == this.selectedUserIdTemp && e.activated === '1' ) ){
        //   this.calendarSelected = ['2']
        // } else {
        //   if (this.settings && this.settings.activated == '0' && !this.hasEmailSynced){
        //     this.calendarSelected = ['2']
        //   }
        // }
        if (this.calendarSelected[0] == '2' ) {

          //si no es un calendar seleccionado por el select
          this.loading = true;

          usersService
            .getClientNylas()
            .then((res) => {
              this.clientNylas = res;
              if (res.time_available != "" && res.time_available != null) {
                this.calendarAvailability = JSON.parse(res.time_available);
              }
              this.modelCalendar.delay_first_date = res.delay_first_date;
              this.modelCalendar.timezone_id = res.timezone_id;
              this.modelCalendar.meet_type = res.meet_type;
              if(res.activated_spark !== null){
                this.addAccount = false
                this.calendarSelected[0]="2"
              }
              if (res.meet_type == 2) {
                this.linkOption = res.link_meet;
                this.modelCalendar.meet_type == 1;
              } else {
                this.modelCalendar.meet_type =
                  res.meet_type != null ? res.meet_type : 1;
              }

              this.meetType = this.modelCalendar.meet_type;
              this.modelCalendar.link_meet = res.link_meet || "";

              this.modelCalendar.delay_first_date = res.delay_first_date
              ? parseInt(res.delay_first_date)
                : 1;

              this.modelCalendar.duration_minutes =
                res.duration_minutes != null && parseInt(res.duration_minutes) > 0
                  ? res.duration_minutes
                  : "30";
              if (
                !["10", "15", "20", "30", "45", "60"].includes(
                  this.modelCalendar.duration_minutes
                )
              ) {
                this.modelCalendar.duration_minutes = undefined;
              }

              this.modelCalendar.interval_minutes =
                res.interval_minutes != null && parseInt(res.interval_minutes) > 0
                  ? res.interval_minutes
                  : "10";

              this.chengeDurationInterval();

              this.modelCalendar.calendar_description = res.calendar_description
                ? res.calendar_description
                : this.$t("lang.appointments.calendar_description_value");

              this.modelCalendar.max_appointments_day = res.max_appointment_day
                ? parseInt(res.max_appointment_day)
                : 10;

              this.modelCalendar.not_available_dates = res.not_available_dates
                ? JSON.parse(res.not_available_dates)
                : [];

              if (res.calendar_ids != undefined || res.calendar_ids != null) {
                this.calendar_ids = JSON.parse(res.calendar_ids);
              }

              (this.calendar_id_selected = res.calendar_selected_id),
                (this.loading = false);
            })
            .then(() => {
              this.loading = true;
              this.getEmailSettings(this.selectedUserIdTemp);



            });
        } else {
          this.loading = false;
          this.showFormTimeAvailable = false;
        }

        });
    }
    this.loading = false;
    });
      }, 4000);
  },
  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    chooseACalendar( id = null) {
      //alert('choose...')

       //this.addAccount = false;
       if(id) this.optionSelectInitial = id;

        //console.log('chooseACalendar-----------xx', this.optionSelectInitial);
      if (parseInt(this.calendarSelected[0]) > 2) {
        //this.oldCalenderSelected =
        this.calendarsNylas.forEach((val) => {
          if (parseInt(this.calendarSelected[0]) == parseInt(val.id)) {
            //console.log('chooseACalendar-----------', val);
            this.getEmailSettings(val.user_id);
          }
        });
      }
    },
    hasEmailSyncronized(){
      if(this.calendarsNylas.find( e => e.user_id == this.selectedUserIdTemp && e.activated === '1')) {
        return true;
      } else {
        return false
      }
    },
    showSyncForm() {
      return (
        this.settings.activated !== undefined &&
        this.settings.activated == 1 &&
        this.calendarSelected[0] == '2'
      );
    },
    itemSelected (node) {
      if (node && node.id !== undefined) {
        this.calendarSelected = [node.id];
      }
      console.log('itemSelected', this.calendarSelected, this.optionSelectInitial, this.calendar_link, this.calendarClientNylasIdSaved)
      //Si seleccion la opcion 1 o 2 del select principal
      if((this.calendar_link != '' && this.calendarClientNylasIdSaved != null || parseInt(this.optionSelectInitial) > 2 )  && parseInt(this.calendarSelected[0]) < 3){
              this.connectExistant();
              this.addNewAccount();
              this.optionSelectInitial = this.calendarSelected[0];
              //this.deactivateEmailSyncronizedWithSale();
      }
      if(this.calendarSelected[0] == '2') {
          this.settings = {};
          this.calendar_link = "";
          this.domaincalendar = "";
          this.isGmailServer = false;
      }



      if ( parseInt(this.calendarSelected[0]) === '1' ) {

        this.getEmailSettings(this.user.id);
      } else {
        this.chooseACalendar(this.oldCalendarSelected);
      }

    },
    getUserHash() {
      return btoa(this.user.id);
    },
    vueAppEnv() {
      return process.env.VUE_APP_ENV;
    },
    changeEmailProvider(provider) {
      this.emailProvider = provider;
    },
    getNylasIntegrationUrl() {
      if (this.checkIntegration === true) {
        return false;
      }
      this.checkIntegration = true;
      let provider = "microsoft";
      if (this.modelCalendar.meet_type == 3) {
        provider = "zoom";
      }
      usersService.getNylasIntegrationUrl(provider).then(
        (res) => {
          if (res) {
            window.location.href = res;
          }
        },
        (error) => {
          if (error == "alreadyexist") {
            this.clientNylas.integration_date = true;
            this.checkIntegration = false;
            return true;
          }
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
          this.checkIntegration = false;
        }
      );
    },
    connectExistant() {
      let calendarSelected = this.calendarSelected

      // if(this.calendarSelected[0] === '2'){
      //   calendarSelected = []
      // }

      if(parseInt(this.calendarSelected[0]) < 3){
          calendarSelected = []
      }

      if(this.calendar_link != '' && parseInt(this.calendarSelected[0]) < 3){
          this.savingData = true;
      }

      this.savingData = true;
      this.saving = true;
      clientsService
        .setExistantCalendar(calendarSelected, this.calendar_link)
        .then((res) => {
          this.savingData = false;

          if (res.calendar_client_nylas_id == null) {
            this.showFormTimeAvailable = true;
          } else {
            //this.showFormTimeAvailable = false;
          }
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.emailSettingSuccessfully"),
            showConfirmButton: false,
            timer: 1500,
          });
          this.saving = false;

          this.calendarClientNylasIdSaved = res.calendar_client_nylas_id;
        });
    },
    showCalendar() {
      return this.user.role_id == 4 || this.user.role_id == 3 || this.user.role_id == 1;
    },
    isSmtp() {
      this.isSmtpServer = true;
      this.isGmailServer = false;
      this.isExchangeServer = false;
      this.emailProvider = "SMTP";
    },
    isGmail() {
      this.isGmailServer = true;
      this.isSmtpServer = false;
      this.isExchangeServer = false;
      this.emailProvider = "Gmail";
    },
    isExchange() {
      this.isExchangeServer = true;
      this.isSmtpServer = false;
      this.isGmailServer = false;
      this.emailProvider = "Exchange";
    },
    changeTab(index) {
      this.activeTabId = this.tabs[index]["id"];
    },
    testTab(item) {
      if (
        this.tabs[item]["roles"] != undefined &&
        $.inArray(parseInt(this.user.role_id), this.tabs[item]["roles"]) == -1
      ) {
        return false;
      }

      return true;
    },
    getEmailSettings(user_id) {
      //this.loading = true;
      this.loadingCalendarSelected = true;
      usersService
        .getEmailSettings(user_id)
        .then((result) => {
          if (result) {
            if (result.domain && result.cloud_dns == "1") {
              this.domaincalendar = result.domain;
            } else {
              this.domaincalendar = "aivoni-ilimited.com";
            }
            this.calendar_link = "https://" + this.domaincalendar + "/calendar/" +  this.getUserHash();

            if (this.settings.email) {
              if (this.settings.activated == 0) {
                this.settings = result;
                if (result.provider == "gmail") {
                  this.isGmail();
                } else if (result.provider == "ews") {
                  this.isExchange();
                } else if (result.provider == "custom") {
                  this.isSmtp();
                }
              }
            } else {
              this.settings = result;
              if (result.provider == "gmail") {
                this.isGmail();
              } else if (result.provider == "ews") {
                this.isExchange();
              } else if (result.provider == "custom") {
                this.isSmtp();
              }
            }
            let isEmailSync = false;
            if (result.email && result.activated == 1) {
              isEmailSync = true;
            }
            this.settings = result;
          } else {
            this.settings = {};
            this.calendar_link = "";
            this.domaincalendar = "";
          }

        })
        .then((result) => {

          this.loading = false;
          this.loadingCalendarSelected = false;
             if (window.location.href.indexOf("state") > -1 && (this.clientNylas.account_id != null ||this.clientNylas.account_id !=undefined )) {
                window.location.href = window.location.pathname
            }
        });
    },
    addNewAccount() {
      this.isSmtpServer = false;
      this.isGmailServer = false;
      this.isExchangeServer = false;
      this.addAccount = true;
      this.settings = {};
    },
    cancel() {
      this.calendarSelected = ['2'];
      //console.log('cancel...calendarSelected....');
    },
    reconnect() {
      this.getEmailSettings(this.selectedUserIdTemp);
      this.addAccount = true;
    },

    deactivateEmailSyncronizedWithSale(){

      if (this.isSalesRep) {
          this.$swal({
            icon: "error",
            type: "error",
            title: 'change...',
            text: this.$t("lang.label.youcannotunsyncsales"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33a2c",
            confirmButtonText: this.$t("lang.integrations.unsync"),
          }).then((result) => {
            if (result.value) {
              this.connectExistant();
              this.addNewAccount();
              this.optionSelectInitial = this.calendarSelected[0];
            } else {
                this.calendarSelected[0] = this.optionSelectInitial;
            }
          });
        } else {
          campaignsService.getActiveCampaigns().then((result) => {
            if (result.total > 0) {
              this.$swal({
                icon: "error",
                type: "error",
                title: this.$t("lang.label.attention"),
                text: this.$t("lang.label.youcannotunsync"),
                showCancelButton: false,
              });
            }
          });
        }
    },

    deactivate() {
      let provider = this.settings.provider;
      if (["gmail", "eas", "ews", "custom"].includes(provider)) {
        if (this.isSalesRep) {
          this.$swal({
            icon: "error",
            type: "error",
            title: this.$t("lang.label.attention"),
            text: this.$t("lang.label.youcannotunsyncsales"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33a2c",
            confirmButtonText: this.$t("lang.integrations.unsync"),
          }).then((result) => {
            if (result.value) {
              this.deactiveAccount();
            }
          });
        } else {
          campaignsService.getActiveCampaigns().then((result) => {
            if (result.total > 0) {
              this.$swal({
                icon: "error",
                type: "error",
                title: this.$t("lang.label.attention"),
                text: this.$t("lang.label.youcannotunsync"),
                showCancelButton: false,
              });
            } else {
              this.deactiveAccount();
            }
          });
        }
      } else {
        this.loading = true;
        this.settings = {};
        smtpMailboxesService.deactivate().then((result) => {
          this.getEmailSettings(this.selectedUserIdTemp);
          this.addAccount = false;
        });
      }
    },

    deactiveAccount() {
      this.loading = true;
      this.settings = {};
      usersService
        .deactivateEmailSettings(this.selectedUserIdTemp)
        .then((result) => {
          this.getEmailSettings(this.selectedUserIdTemp);
          this.clientNylas.account_id = null;
          this.addAccount = false;
          this.calendarSelected = ['2']
          this.calendar_link = ''
          this.loading = false;

          this.settings = {};
          this.calendar_link = "";
          this.domaincalendar = "";
          this.isGmailServer = false;
        });
    },

    setIsEmailSync(isEmailSync) {
      const { dispatch } = this.$store;
      dispatch("authentication/setIsEmailSync", isEmailSync);
    },
    changeMeetType(model, newVal, oldVal, field) {
      this.meetType = model.meet_type;
    },
    selectTimeZone() {},
    SetAvailability(days) {
      this.calendarAvailability = days;
    },

    addNotAvailableDate() {
      this.modelCalendar.not_available_dates.push({ from: "", to: "" });
    },

    removeNotAvailableDate(index) {
      this.modelCalendar.not_available_dates.splice(index, 1);
    },

    updateData(event) {
      this.calendar_ids = [];
      event.map((item) => {
        this.calendar_ids.push(item.id);
      });
    },
    updateSelectCalendar(choose) {
      this.calendar_id_selected = choose;
    },
    saveTimeAvailable() {
      if (
        (this.linkOption == "" && this.modelCalendar.meet_type == 2) ||
        this.calendarAvailability.length == 0
      ) {
        this.$swal({
          type: "warning",
          html: this.$t("lang.label.missingdata"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("lang.button.ok"),
          cancelButtonColor: "#d33a2c",
        });
        return false;
      }

      if (availabilityHasOverlap(this.calendarAvailability)) {
        this.$swal({
          type: "warning",
          html: this.$t("lang.calendar.overlappingSlots"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("lang.button.ok"),
        });
        return false;
      }

      let data = {
        timezone_id: this.modelCalendar.timezone_id,
        calendar_link: this.calendar_link,
        meet_type: this.modelCalendar.meet_type,
        hours: this.selectedHours,
        duration_minutes: this.modelCalendar.duration_minutes,
        hours: this.calendarAvailability,
        user_id: this.selectedUserIdTemp,
        interval_minutes: this.modelCalendar.interval_minutes,
        link_meet:
          this.modelCalendar.meet_type == 1
            ? (this.modelCalendar.link_meet || "").trim()
            : this.linkOption,
        calendar_description: this.modelCalendar.calendar_description,
        max_appointment_day: this.modelCalendar.max_appointments_day,
        calendar_ids: this.calendar_ids,
        calendar_selected_id: this.calendar_id_selected,
        delay_first_date: this.modelCalendar.delay_first_date,
        not_available_dates: this.modelCalendar.not_available_dates.filter(item => item.from)
      };

      this.$refs.calendarForm.validate();
      if (this.$refs.calendarForm.errors.length > 0 || data.hours.length == 0) {
        this.$swal({
          type: "warning",
          html: this.$t("lang.label.missingdata"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("lang.button.ok"),
          cancelButtonColor: "#d33a2c",
        });
        return false;
      }
      this.timeSaving = true;
      myCalendarService
        .saveTimeAvailable(data)
        .then((res) => {
          if (res) {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              html: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.timeSaving = false;
          }
        })
        .catch((err) => {
          //("error", err);
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: false,
            timer: 9000,
          });
          this.timeSaving = false;
        });
    },

    deleteAgenda(){
      myCalendarService.deleteAgenda().then((res)=>{
        window.location.reload();
      })
    },
    chengeDurationInterval() {
      let values = [
        {
          id: "0",
          name: "0",
        },
      ];
      let durations = [10, 15, 20, 30, 60]; // factores de 60
      let currentDuration = this.modelCalendar.duration_minutes;
      let intervals = [0];

      durations.forEach((item) => {
        if (currentDuration < item && currentDuration < 60) {
          let interval_1 = item - currentDuration;
          if (!intervals.includes(interval_1)) {
            intervals.push(interval_1);
          }
          let interval_2 = item + interval_1;
          if (!intervals.includes(interval_1)) {
            intervals.push(interval_2);
          }
        } else if (currentDuration == 60) {
          let interval_1 = 60 - currentDuration;
          if (!intervals.includes(interval_1)) {
            intervals.push(interval_1);
          }
        }
      });

      intervals.forEach((item) => {
        if (item > 0) {
          values.push({
            id: "" + item,
            name: "" + item,
          });
        }
      });
      if (this.$refs.calendarFormfields === undefined) {
        this.meetIntervalTime = values;
      } else {
        var field = this.$refs.calendarFormfields.find(
          (field) => field.model === "interval_minutes"
        );
        field.values = values;
      }

      if (!intervals.includes(parseInt(this.modelCalendar.interval_minutes))) {
        this.modelCalendar.interval_minutes = 0;
      }
    },
  },
};
</script>
<style>
.email-account .btn-light {
  width: 160px;
  height: 100px;
}
.email-account .icon img {
  width: 25px;
}
.email-account .icon-account img {
  width: 40px;
}
.email-account .icon-envelope-open-o:before {
  font-size: 25px;
}

.input-group-text.icon-check-circle {
  color: #52be80;
}

.form-group.field-treeselect.error .vue-treeselect__control {
  border: 1px solid red;
  background-color: rgba(255, 0, 0, 0.15);
}

.form-group.field-treeselect.error input:not([type="checkbox"]) {
  border: 0px;
  background-color: transparent;
}

.button {
  background-color: blue;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.button.loading {
  background-color: gray;
  cursor: wait;
}

.button.loading span:first-child {
  display: none;
}

.button.loading span:last-child {
  display: inline-block;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.btn-processing .icon-spinner {
  animation: spin 1s linear infinite;
}
</style>
